import { ShiftState } from "./types";

const initialState: ShiftState = {
  maxDateTime: null,
};

export const shiftReducer = (state = initialState, action: any): ShiftState => {
  switch (action.type) {
    case 'SET_MAX_DATE_TIME':
      return {
        ...state,
        maxDateTime: action.payload,
      };
    default:
      return state;
  }
};
